import React from "react";
import classNames from "classnames";
import currencyFormatter, { Currency } from "../../../../js/common/CurrencyFormatter";
import { FilterValues } from "./FilterValuesCollection";

interface ProductListPriceFilterProperties {
    readonly isActive: boolean;
    readonly minPrice: number;
    readonly maxPrice: number;
    readonly currency: Currency;
    readonly filter: FilterValues;
    readonly isSoldProductsPage: boolean;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

const getPriceRanges = (currency: Currency): number[] => {
    switch (currency) {
        case Currency.CZK:
            return [0, 50, 100, 200, 500, 1000, 2000, 5000];
        case Currency.EUR:
            return [0, 2, 4, 8, 20, 40, 200];
        case Currency.PLN:
            return [0, 10, 20, 40, 100, 200, 400];
    }
};

export default function ProductListPriceFilter({
    isActive,
    minPrice,
    maxPrice,
    currency,
    filter,
    isSoldProductsPage,
    onFilterChange,
    onActivateTab,
}: ProductListPriceFilterProperties): React.JSX.Element | undefined {
    if (isSoldProductsPage) {
        return undefined;
    }

    const setMinValue = (price: number): void => {
        if (Number.isNaN(price)) {
            return;
        }

        onFilterChange(Object.assign({}, filter, { PriceRange: [price, filter.PriceRange?.[1]] }));
    };

    const setMaxValue = (price: number): void => {
        if (Number.isNaN(price)) {
            return;
        }

        onFilterChange(Object.assign({}, filter, { PriceRange: [filter.PriceRange?.[0], price] }));
    };

    return (

        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Cena<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", "price-filter", { hidden: !isActive })}>
                <p>Zadejte rozsah ceny k filtrování</p>

                <input
                    type="text" placeholder="cena od" value={filter.PriceRange?.[0] ?? ""}
                    onChange={(event) => setMinValue(Number(event.target.value))}
                /> {currencyFormatter.formatSymbol(currency)}
                <div className="price-filter-buttons">
                    {getPriceRanges(currency).slice(0, -1)
                        .map((priceRange) => <button type="button" key={priceRange} onClick={() => setMinValue(priceRange)}>{currencyFormatter.formatCurrencyWithSymbol(priceRange, currency)}</button>)}
                </div>

                <input
                    type="text" placeholder="cena do" value={filter.PriceRange?.[1] ?? ""}
                    onChange={(event) => setMaxValue(Number(event.target.value))}
                /> {currencyFormatter.formatSymbol(currency)}
                <div className="price-filter-buttons">
                    {getPriceRanges(currency).slice(1)
                        .map((priceRange) => <button type="button" key={priceRange} onClick={() => setMaxValue(priceRange)}>{currencyFormatter.formatCurrencyWithSymbol(priceRange, currency)}</button>)}
                </div>

                <p>
                    <span>Nejlevnější produkt za </span>
                    <strong>{currencyFormatter.formatCurrencyWithSymbol(minPrice, currency)}</strong>.
                </p>

                <p>
                    <span>Nejdražší produkt za </span>
                    <strong>{currencyFormatter.formatCurrencyWithSymbol(maxPrice, currency)}</strong>.
                </p>
            </div>
        </div>

    );
}
